module.exports = __webpack_public_path__ + "static/img/30017 (2).5acc32c.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30017 (2).webp
// module id = Mn0k
// module chunks = 14